module.exports = __webpack_public_path__ + "static/media/pranita-avatar.828d856c.jpg";